export default "__VITE_ASSET__BfRR979U__"